
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/samochody-ciezarowe/[marka]/lokalizacja/[lokalizacja]",
      function () {
        return require("private-next-pages/samochody-ciezarowe/[marka]/lokalizacja/[lokalizacja]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/samochody-ciezarowe/[marka]/lokalizacja/[lokalizacja]"])
      });
    }
  